export enum EstateTypeDto {
  SingleUnit = 'SingleUnit',
  MultiUnit = 'MultiUnit',
}
